import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { getRecaptchaSiteKey, RecaptchaMode } from "src/hooks/useRecaptcha";

type Props = {
  title?: string;
  description?: string;
  keywords?: string;
  imgsrc?: string;
  url?: string;
  isReCAPTCHA?: boolean;
  reCaptchaMode?: RecaptchaMode;
  naverLanguage?: string;
};

/**
 * SEO meta tag 컴포넌트
 * @param title : 기본 "Taap"
 */

export default function MetaTag({
  title,
  description,
  keywords,
  imgsrc = `${process.env.REACT_APP_S3_CONTENT_BASEURL}court/taapspace_logo.png`,
  url,
  isReCAPTCHA = false,
  reCaptchaMode = "score",
  naverLanguage,
}: Props) {
  const reCAPTCHAsiteKey = getRecaptchaSiteKey(reCaptchaMode);
  useEffect(() => {
    const grecaptchaBadge = document.querySelector(".grecaptcha-badge");
    if (!isReCAPTCHA && grecaptchaBadge) {
      grecaptchaBadge.remove();
    }
  }, [isReCAPTCHA]);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="format-detection" content="telephone=yes" />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:type" content="website" />
      {/* <meta property="og:title" content={title} /> */}
      {/* {description && <meta property="og:description" content={description} />} */}
      {/* {imgsrc && <meta property="og:image" content={imgsrc} />} */}
      <meta property="og:site_name" content={title} />
      {url && <meta property="og:url" content={url} />}

      {url && <link rel="canonical" href={url} />}
      {isReCAPTCHA && <script src={`https://www.google.com/recaptcha/enterprise.js?render=${reCAPTCHAsiteKey}&language=${naverLanguage}`}></script>}
      {/* 네이버 지도 신규 Maps API: oapi.map.naver.com + ncpKeyId (구 openapi.map.naver.com + ncpClientId 는 종료 예정) */}
      {naverLanguage && (
        <script
          id="navermap"
          type="text/javascript"
          src={`https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${process.env.REACT_APP_NAVER_CLOUD_CLIENT_ID}&submodules=geocoder&language=${naverLanguage}`}
        ></script>
      )}
    </Helmet>
  );
}
